module.exports = __webpack_public_path__ + "media/assets/images/flags/ph-15e3a7dd0e2a16408fc343e22fd86e00.svg";